import React from 'react';

const PDFUpdateView = React.lazy(() => import('views/Portal/Updates/View'));
const PDFExitStatementView = React.lazy(
  () => import('views/Portal/ExitStatement/ViewExitStatement'),
);
const PDFUpdateDownload = React.lazy(
  () => import('views/Portal/Updates/Download'),
);
const PDFExitStatementDownload = React.lazy(
  () => import('views/Portal/ExitStatement/Download'),
);
const AdviserEntryPage = React.lazy(() => import('views/Adviser/EntryPage'));
const AdminImpersonationEntry = React.lazy(
  () => import('views/AdminImpersonationEntry'),
);

export const ADMIN_IMPERSONATION_ENTRY =
  '/admin-impersonation-entry/:token/:redirectTo?';

const customRoutes = [
  {
    exact: true,
    path: '/updates/:reportingId/:investmentId?',
    name: 'PDFUpdatesView',
    component: PDFUpdateView,
  },
  {
    exact: true,
    path: '/updates-download/:reportingId/:investorId',
    name: 'PDFUpdatesDownload',
    component: PDFUpdateDownload,
  },
  {
    exact: true,
    path: '/view-exit-statement/:exitStatementId/:investmentId?',
    name: 'PDFExitStatementView',
    component: PDFExitStatementView,
  },
  {
    exact: true,
    path: '/exit-statement/download/:exitStatementId/:investmentId?',
    name: 'PDFExitStatementDownload',
    component: PDFExitStatementDownload,
  },
  {
    exact: true,
    path: '/adviser-entry',
    name: 'AdviserEntryPage',
    component: AdviserEntryPage,
  },
  {
    path: ADMIN_IMPERSONATION_ENTRY,
    exact: true,
    name: 'AdminImpersonationEntry',
    component: AdminImpersonationEntry,
  },
];

export default customRoutes;
